// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2168":"3a1efa24df125221","7695":"ff82be20a48011d5"}[chunkId] + ".css";
};